export default "__VITE_ASSET__acab252a__"